import Vue from 'vue'
import authorization from '@/utils/authorization'

function sortByColor (a, b) {
  if (a.color === b.color) return 0
  if (a.color === 'red' && b.color !== 'red') return -1
  if (a.color === 'orange' && b.color === 'blue') return -1
  if (a.color === 'orange' && b.color === 'gray') return -1
  if (a.color === 'blue' && b.color === 'gray') return -1
  return 1
}

function sortByAlarmAt (a, b) {
  return new Date(b.lastAlarmAt) - new Date(a.lastAlarmAt)
}

function sortByName (a, b) {
  return a.name > b.name ? 1 : -1
}

// initial state
const state = {
  realEstates: [
    // {
    //   id: '5250',
    //   name: 'Solna Nationalarenan 8',
    //   block: 'Arenastaden',
    //   hasInfo: false,
    //   // info: 'Vi har lite probem med ett system just nu, så det kan bli många larm här.',
    //   // infoAtText: '8 h sedan',
    //   // infoBy: 'Bengt Bergius',
    //   hasLinks: false,
    //   links: [],
    //   lat: 59.3693305,
    //   lng: 18.0044783,
    //   color: 'orange',
    //   alarmCount: 1,
    //   alarmingCategories: ['Kommunikation'],
    //   alarmingSystems: ['Larmia'],
    //   lastAlarmAt: '2019-06-13T09:45:34+01:00',
    //   mine: true,
    //   _renderHeader: true
    // }
  ]
}

// getters
const getters = {
  all: state => state.realEstates.filter(re => re.alarmCount >= 0).sort(sortByColor),
  alarming: (state, getters) => getters.all.filter(re => re.alarmCount > 0),
  find: (state, getters) => (id) => getters.all.find(re => re.id === id),
  byBlock: (state, getters) => (block) => getters.all.filter(re => re.block === block),
  byBlockAlarming: (state, getters) => (block) => getters.alarming.filter(re => re.block === block),
  blocks: (state, getters) => [...new Set(getters.all.map(re => re.block).sort())],
  blocksAlarming: (state, getters) => [...new Set(getters.alarming.map(re => re.block).sort())],
  byIDs: (state, getters) => (ids) => {
    return getters.all.filter(re => ids.indexOf(re.id) !== -1)
  },
  byIDsAlarming: (state, getters) => (ids) => {
    return getters.alarming.filter(re => ids.indexOf(re.id) !== -1)
  }
}

// actions

const actions = {

  async preloadRealEstates ({ state, dispatch }) {
    if (!authorization.authorize()) return
    if (state.realEstates.length > 0) return
    await dispatch('fetchRealEstates')
  },

  async fetchRealEstates ({ commit }) {
    const res = await Vue.axios.get('/api/realestates/')
    if (res.status === 200) commit('setRealEstates', res.data.realEstates)
  },

  async updateInfo ({ commit, dispatch }, val) {
    const res = await Vue.axios.post(`/api/realestates/${val.id}/note`, { note: val.text })
    if (res.status === 200) await dispatch('fetchRealEstates')
  },

  async updateLinks ({ commit, dispatch }, val) {
    const res = await Vue.axios.post(`/api/realestates/${val.id}/links`, { links: val.links })
    if (res.status === 200) await dispatch('fetchRealEstates')
  }

}

// mutations
const mutations = {
  setRealEstates (state, realEstates) {
    state.realEstates = realEstates.sort(sortByName).sort(sortByAlarmAt)
  }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/real_estate.js